import { Routes } from '@angular/router';
import { canActivateAuthRole, i18nResolver } from 'O3_core';
import { GLOBAL_AUDIT_PROVIDERS } from '../providers/audit.providers';
import { Landing } from '../layout/landing/landing';
import { Forbidden } from '../layout/forbidden/forbidden';
import { PageNotFound } from '../layout/page-not-found/page-not-found';
import enPublicConsentsTranslations from '../layout/public-consents/locales/en/resources.json';
import roPublicConsentsTranslations from '../layout/public-consents/locales/ro/resources.json';

export const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  { path: 'landing', component: Landing },
  {
    // One screen, two ways in: an anonymous visitor types the reception code,
    // a session carrying the Tablet role waits to be sent a patient. The
    // component picks the entry from the token, so the URL stays the same.
    path: 'public/consents',
    data: {
      viewKey: 'PublicConsents_MainView',
      enTranslations: enPublicConsentsTranslations,
      roTranslations: roPublicConsentsTranslations,
    },
    resolve: { i18nResolverData: i18nResolver },
    loadComponent: () =>
      import('../layout/public-consents/consents').then((c) => c.Consents),
  },
  {
    path: 'identity',
    canActivate: [canActivateAuthRole],
    loadChildren: () => import('O3_identity').then((c) => c.routes),
  },
  {
    path: 'dashboard',
    canActivate: [canActivateAuthRole],
    loadChildren: () => import('O3_reporting').then((c) => c.routes),
  },
  {
    path: 'reporting',
    canActivate: [canActivateAuthRole],
    loadChildren: () => import('O3_reporting').then((c) => c.routes),
  },
  {
    path: 'patient-management',
    canActivate: [canActivateAuthRole],
    loadChildren: () => import('O3_patient-management').then((c) => c.routes),
  },
  {
    path: 'structure',
    canActivate: [canActivateAuthRole],
    loadChildren: () => import('O3_structure').then((c) => c.routes),
  },
  {
    path: 'system-catalogs',
    canActivate: [canActivateAuthRole],
    loadChildren: () => import('O3_system-catalogs').then((c) => c.routes),
  },
  {
    path: 'financials',
    canActivate: [canActivateAuthRole],
    loadChildren: () => import('O3_financials').then((c) => c.routes),
  },
  {
    path: 'scheduler',
    canActivate: [canActivateAuthRole],
    loadChildren: () => import('O3_scheduler').then((c) => c.routes),
  },
  {
    path: 'chemotherapy',
    canActivate: [canActivateAuthRole],
    loadChildren: () => import('O3_chemotherapy').then((c) => c.routes),
  },
  {
    path: 'radiotherapy',
    canActivate: [canActivateAuthRole],
    loadChildren: () => import('O3_radiotherapy').then((c) => c.routes),
  },
  {
    path: 'oncology-catalogs',
    canActivate: [canActivateAuthRole],
    loadChildren: () => import('O3_oncology-catalogs').then((c) => c.routes),
  },
  {
    path: 'stock-management',
    canActivate: [canActivateAuthRole],
    loadChildren: () => import('O3_stock-management').then((c) => c.routes),
  },
  {
    path: 'cnas',
    canActivate: [canActivateAuthRole],
    loadChildren: () => import('O3_cnas').then((c) => c.routes),
  },
  {
    path: 'file-storage',
    canActivate: [canActivateAuthRole],
    loadChildren: () => import('O3_file-storage').then((c) => c.routes),
  },
  {
    path: 'job-scheduler',
    canActivate: [canActivateAuthRole],
    loadChildren: () => import('O3_job-scheduler').then((c) => c.routes),
  },
  {
    path: 'notifications',
    canActivate: [canActivateAuthRole],
    loadChildren: () => import('O3_notifications').then((c) => c.routes),
  },
  {
    path: 'pathological-anatomy',
    canActivate: [canActivateAuthRole],
    loadChildren: () => import('O3_pathological-anatomy').then((c) => c.routes),
  },
  {
    path: 'template-manager',
    canActivate: [canActivateAuthRole],
    loadChildren: () => import('O3_template-manager').then((c) => c.routes),
  },
  {
    path: 'audit',
    canActivate: [canActivateAuthRole],
    providers: GLOBAL_AUDIT_PROVIDERS,
    loadChildren: () => import('O3_audit').then((c) => c.routes),
  },
  {
    path: 'communication',
    canActivate: [canActivateAuthRole],
    loadChildren: () => import('O3_communication').then((c) => c.routes),
  },
  {
    // Authentication only — "My tickets" must be reachable by every user.
    // The console's own routes carry the support scope guards.
    path: 'support',
    canActivate: [canActivateAuthRole],
    loadChildren: () => import('O3_support').then((c) => c.routes),
  },
  {
    path: 'forbidden',
    canActivate: [canActivateAuthRole],
    component: Forbidden,
  },
  { path: 'not-found', component: PageNotFound },
  { path: '**', redirectTo: '/not-found' },
];
